import React from "react";
import { Link } from "react-router-dom";
import "./PageNotFound.css";

const PageNotFound = () => {
  return (
    <div className="not-found-page">
      <main className="not-found-hero">
        <div className="not-found-content">
          <div className="not-found-code" aria-hidden="true">
            404
          </div>

          <h1 className="not-found-title">
            This page went <span>off-chain.</span>
          </h1>

          <p className="not-found-description">
            The page you’re looking for may have moved, been removed, or never
            made it onto the network.
          </p>

          <div className="not-found-actions">
            <Link to="/" className="not-found-primary-link">
              <span>Back to Home</span>
              <span className="material-symbols-outlined" aria-hidden="true">
                arrow_forward
              </span>
            </Link>

            <Link to="/user/projects" className="not-found-secondary-link">
              Explore Projects
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PageNotFound;
